import { FormattedMessage } from 'react-intl';

import { Link } from '@mui/material';

import { ROUTES } from '@arrived/common';

export const ReservationDisclaimer = () => {
  return (
    <FormattedMessage
      id="reservation-disclaimer-text"
      defaultMessage={`Arrived Homes, LLC (the "Company") intends to sponsor a securities offering with respect to
      this property pursuant to Regulation A under the Securities Act of 1933. The Company is now "testing the waters"
      to gauge market demand and it is under no obligation to make an offering under Regulation A. No money or other
      consideration is being solicited in connection with the information that is now being provided, and if money is
      sent in response, it will not be accepted. No offer to buy our securities can be accepted and no part of the
      purchase price can be received until an offering statement on Form 1-A has been filed with and qualified by the
      Securities and Exchange Commission, and any such offer may be withdrawn or revoked, without obligation or
      commitment of any kind, at any time before notice of its acceptance given after the Form 1-A qualification date.
      A person's indication of interest involves no obligation or commitment of any kind.
      {br}{br}
      For additional risk factors and disclaimer information, you can review our {communicationsDisclaimerLink}.`}
      values={{
        br: <br />,
        communicationsDisclaimerLink: (
          <Link href={ROUTES.communicationsDisclaimer}>
            <FormattedMessage
              id="reservation-disclaimer-communications-disclaimer-link-text"
              defaultMessage="communications disclaimer"
            />
          </Link>
        ),
      }}
    />
  );
};
